import { Config } from 'common/config'
import { useTranslation } from 'react-i18next'
import { Container, ItemsList, LinkText, LinkItem } from './styled'
import { useLocation, useNavigate } from 'react-router-dom'

export const Menu = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { pathname } = useLocation()
  const isBanquetPage = pathname.includes('/banquet')
  const items = [
    {
      title: t('about.us'),
      href: pathname.includes('/banquet') ? '/' : `#${Config.Section.aboutUs}`,
    },
    {
      title: t('other.bookmarks'),
      href: pathname.includes('/banquet')
        ? '/'
        : `#${Config.Section.anotherRestaurants}`,
    },
    {
      title: t('contacts'),
      href: `#${Config.Section.contacts}`,
    },
  ]
  const onItemClick = (item: { title: string; href: string }) => {
    if (isBanquetPage && item.href === '/') {
      navigate('/')

      return
    }
    const section = document.getElementById(item.href.replace('#', ''))
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' })
    }
  }
  return (
    <>
      <Container>
        <ItemsList>
          {items.map((item, index) => (
            <LinkItem onClick={() => onItemClick(item)} key={index}>
              <LinkText>{item.title}</LinkText>
            </LinkItem>
          ))}
        </ItemsList>
      </Container>
    </>
  )
}
